// French Product Handle
(() => {
    'use strict';
    
    let attempts = 0;
    const maxAttempts = 20;
    const retryDelay = 500;
    
    const convertFrenchHandleToEnglish = () => {
      const productContainer = document.querySelector('.product-detail');
      
      if (!productContainer) {
        if (attempts < maxAttempts) {
          attempts++;
          setTimeout(convertFrenchHandleToEnglish, retryDelay);
        }
        return;
      }
      
      let englishHandle = null;
      let variantId = null;
      let productId = null;
      
      const alternateLink = document.querySelector('link[rel="alternate"][hreflang="en"], link[rel="alternate"][hreflang="en-US"]');
      if (alternateLink) {
        const href = alternateLink.getAttribute('href');
        const match = href.match(/\/products\/([^\/\?#]+)/);
        if (match) {
          englishHandle = match[1];
        }
      }
      
      if (!englishHandle) {
        const currentUrl = window.location.pathname;
        const englishUrl = currentUrl.replace('/fr/', '/');
        
        fetch(`${englishUrl}.js`)
          .then(res => res.json())
          .then(data => {
            englishHandle = data.handle;
            applyAttributes(englishHandle, variantId, productId, productContainer);
          })
          .catch(() => {
            const frenchHandle = currentUrl.match(/\/products\/([^\/\?]+)/);
            if (frenchHandle) {
              englishHandle = frenchHandle[1]
                .replace(/bracelet-raffine/gi, 'refined-bracelet')
                .replace(/collier-fort/gi, 'strong-necklace')
                .replace(/collier-perle/gi, 'pearl-necklace')
                .replace(/^bracelet-/gi, 'bracelet-')
                .replace(/^collier-/gi, 'necklace-')
                .replace(/^bague-/gi, 'ring-')
                .replace(/^boucles-/gi, 'earrings-');
              applyAttributes(englishHandle, variantId, productId, productContainer);
            }
          });
      }
      
      const productJsonScript = productContainer.querySelector('script[id^="ProductJson-"]') || 
                                 document.querySelector('.product-detail script[id^="ProductJson-"]');
      if (productJsonScript) {
        try {
          const productData = JSON.parse(productJsonScript.textContent);
          productId = productData.id;
          
          if (productData.variants && productData.variants.length > 0) {
            variantId = productData.variants[0].id;
          }
        } catch (e) {}
      }
      
      const variantSelect = productContainer.querySelector('select[name="id"]');
      if (!variantId && variantSelect) {
        variantId = variantSelect.value;
      }
      
      if (englishHandle) {
        applyAttributes(englishHandle, variantId, productId, productContainer);
      }
    };
    
    const applyAttributes = (englishHandle, variantId, productId, productContainer) => {
      if (!productContainer) {
        productContainer = document.querySelector('.product-detail');
      }
      
      if (!productContainer) return;
      
      if (englishHandle) {
        productContainer.setAttribute('data-product-handle', englishHandle);
        productContainer.setAttribute('product-handle', englishHandle);
      }
      
      if (variantId) {
        productContainer.setAttribute('data-variant-id', variantId);
      }
      
      if (productId) {
        productContainer.setAttribute('data-product-id', productId);
      }
      
      const variantSelect = productContainer.querySelector('select[name="id"]');
      if (variantSelect) {
        variantSelect.removeEventListener('change', handleVariantChange);
        variantSelect.addEventListener('change', handleVariantChange);
      }
      
      if (window.Abra && typeof window.Abra.render === 'function') {
        window.Abra.render();
      }
    };
    
    const handleVariantChange = (e) => {
      const productContainer = document.querySelector('.product-detail');
      if (productContainer) {
        productContainer.setAttribute('data-variant-id', e.target.value);
        if (window.Abra && typeof window.Abra.render === 'function') {
          window.Abra.render();
        }
      }
    };
    
    if (window.location.pathname.includes('/fr/products/')) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', convertFrenchHandleToEnglish);
      } else {
        convertFrenchHandleToEnglish();
      }
      
      window.addEventListener('load', () => {
        setTimeout(convertFrenchHandleToEnglish, 1000);
      });
      
      const observer = new MutationObserver(() => {
  
        const productDetail = document.querySelector('.product-detail');
        if (productDetail && attempts === 0) {
          convertFrenchHandleToEnglish();
          observer.disconnect();
        }
      });
      
      observer.observe(document.body, { childList: true, subtree: true });
    }
  })();
  
  (() => {
    'use strict';
    
    let attempts = 0;
    const maxAttempts = 20;
    const retryDelay = 500;
    const processedCards = new Set();
    
    const getEnglishHandle = async (productId, productLink) => {
      try {
        const response = await fetch(`/products/${productId}.js`);
        if (response.ok) {
          const data = await response.json();
          return data.handle;
        }
      } catch (e) {}
      
      try {
        const productUrl = productLink.getAttribute('href');
        const fullUrl = productUrl.startsWith('http') ? productUrl : `${window.location.origin}${productUrl}`;
        const response = await fetch(fullUrl);
        
        if (response.ok) {
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const alternateLink = doc.querySelector('link[rel="alternate"][hreflang="en"], link[rel="alternate"][hreflang="en-US"]');
          
          if (alternateLink) {
            const href = alternateLink.getAttribute('href');
            const match = href.match(/\/products\/([^\/\?#]+)/);
            if (match) return match[1];
          }
        }
      } catch (e) {}
      
      return null;
    };
    
    const processCard = async (card) => {
      const productId = card.getAttribute('data-product-id');
      if (processedCards.has(productId)) return;
      
      const productLink = card.querySelector('a.product-link[href*="/products/"]');
      if (!productLink) return;
      
      const englishHandle = await getEnglishHandle(productId, productLink);
      
      if (englishHandle) {
        card.setAttribute('data-product-handle', englishHandle);
        card.setAttribute('product-handle', englishHandle);
        
        const priceWrapper = card.querySelector('.product-price__wrapper');
        if (priceWrapper) {
          priceWrapper.setAttribute('data-product-handle', englishHandle);
        }
        
        processedCards.add(productId);
      }
    };
    
    const processAllCards = async () => {
      if (!window.location.pathname.includes('/fr/')) return;
      
      const productCards = document.querySelectorAll('.product-block[data-product-id]');
      
      if (productCards.length === 0) {
        if (attempts < maxAttempts) {
          attempts++;
          setTimeout(processAllCards, retryDelay);
        }
        return;
      }
      
      let processedCount = 0;
      
      for (const card of productCards) {
        const productId = card.getAttribute('data-product-id');
        if (!processedCards.has(productId)) {
          await processCard(card);
          processedCount++;
          await new Promise(resolve => setTimeout(resolve, 200));
        }
      }
      
      if (processedCount > 0 && window.Abra && typeof window.Abra.render === 'function') {
        setTimeout(() => window.Abra.render(), 500);
      }
    };
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', processAllCards);
    } else {
      processAllCards();
    }
    
    window.addEventListener('load', () => setTimeout(processAllCards, 1000));
    setTimeout(processAllCards, 2000);
    
    const observer = new MutationObserver(() => {
      const unprocessedCards = Array.from(document.querySelectorAll('.product-block[data-product-id]'))
        .filter(card => !processedCards.has(card.getAttribute('data-product-id')));
      
      if (unprocessedCards.length > 0) {
        setTimeout(processAllCards, 300);
      }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
  })();

// Cart Auto-Refresh
(() => {
  const triggerCartUpdate = () => {
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('slidecart:updated', { 
        detail: {
          count: document.querySelector('.slidecarthq .cart-count')?.textContent,
          items: document.querySelectorAll('.slidecarthq .item').length,
          subtotal: document.querySelector('.slidecarthq .slidecart-subtotal')?.textContent
        }
      }));
    }, 50);
  };

  document.addEventListener('click', (e) => {
    const target = e.target.closest('button');
    if (!target) return;

    if (target.matches('.quantity-selector button') || 
        target.matches('.remove') ||
        target.matches('.upsell-add button') ||
        target.matches('.upsell-options button')) {
      triggerCartUpdate();
    }
  });

  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change'))) {
      return originalFetch.apply(this, args).then(response => {
        triggerCartUpdate();
        return response;
      });
    }
    return originalFetch.apply(this, args);
  };
})();